import React from "react";
import PlayerAssetsPage from "./PlayerAssetsPage";
import { PLAYER_ASSET_TYPES } from "../../../constants/playerAssetTypes";

const PlayerAvatarsPage = () => <PlayerAssetsPage config={PLAYER_ASSET_TYPES.avatar} />;

export default PlayerAvatarsPage;
